import * as types from "./types";
export const loadPageContent = pageSlug => ({
  type: types.LOAD_PAGE_CONTENT,
  pageSlug: pageSlug
});

export const loadPageContentBlocks = pageSlug => ({
  type: types.LOAD_PAGE_CONTENT_BLOCKS,
  pageSlug: pageSlug
});

export const pageContentLoaded = (content, pageSlug) => ({
  type: types.PAGE_CONTENT_LOADED,
  content: content,
  pageSlug: pageSlug
});

export const contentBlocksLoaded = (contentBlocks, pageSlug) => ({
  type: types.PAGE_CONTENT_BLOCKS_LOADED,
  contentBlocks: contentBlocks,
  pageSlug: pageSlug
});
